import { ZonedMoment } from "@clockwise/client-commons/src/util/time-zone";
import { formatNumberAsAbbreviation } from "../overview.util";

export function constructDateRangeTooltip(
  accountingPeriodLength: number,
  x: number,
  y: number,
  name: string,
  color: string,
  suffix: string = "",
) {
  const formattedY = formatNumberAsAbbreviation(y);
  const startDate = new ZonedMoment(x).clone().format("MMM DD");
  const endDate = new ZonedMoment(x)
    .clone()
    .add(accountingPeriodLength - 1, "days")
    .format("MMM DD, YYYY");
  const tooltipHeader = `<small>${startDate} - ${endDate}</small>`;
  const tooltipBody = `<span style="color: ${color};">● </span><span>${name}: <b>${formattedY} ${suffix}</b><span>`;

  const tooltipFormat = `
              <div>${tooltipHeader}<div>
              <div>${tooltipBody}</div>
              `;

  return tooltipFormat;
}

export function constructDatePointTooltip(
  x: number,
  y: number,
  name: string,
  color: string,
  suffix: string = "",
) {
  const formattedY = formatNumberAsAbbreviation(y);
  const startDate = new ZonedMoment(x).clone().format("MMM DD, YYYY");
  const tooltipHeader = `<small>${startDate}</small>`;
  const tooltipBody = `<span style="color: ${color};">● </span><span>${name}: <b>${formattedY} ${suffix}</b><span>`;

  const tooltipFormat = `
              <div>${tooltipHeader}<div>
              <div>${tooltipBody}</div>
              `;

  return tooltipFormat;
}

// NB: this is a workaround to accommodate a known highcharts issue
// https://github.com/highcharts/highcharts/issues/1441#issuecomment-754618552
export function getTickPositions(data: [number, number][], tickPositions: any) {
  const isDayOrWeekDisplay =
    tickPositions.info?.unitName === "week" || tickPositions.info?.unitName === "day";

  // only set tick positions for day or week views
  // and let highcharts set them for month or more
  if (isDayOrWeekDisplay && tickPositions.info?.count > 1) {
    // To account for incorrect typings on tickPositioner
    let newTicks = data.map(([dateLabel]) => dateLabel) as any;
    newTicks.info = tickPositions.info;
    return newTicks;
  }

  return tickPositions;
}
